// Bundles that ship as ES modules (have import/export). Must match exactly
// — broadband-lazy-load and broadband-observer are also `.bundle.js` but
// classic, so a blanket suffix check would mistakenly mark them as modules.
const MODULE_BUNDLE_MATCHERS = ['/broadband.', '/broadband-vendor.'];

const isModuleBundle = (url: string): boolean =>
    url.endsWith('.bundle.js') &&
    MODULE_BUNDLE_MATCHERS.some((m) => url.includes(m));

class AssetLoader {
    private loadedAssets = new Set();

    public addScript = (url: string): Promise<void> => {
        return new Promise((resolve) => {
            if (
                this.loadedAssets.has(url) ||
                this.checkForExistingScript(url)
            ) {
                resolve();
            } else {
                this.loadedAssets.add(url);
                const script = document.createElement('script');
                script.setAttribute('src', url);
                if (isModuleBundle(url)) {
                    script.setAttribute('type', 'module');
                }
                script.onload = () => resolve();
                document.head.appendChild(script);
            }
        });
    };
    public addCss = (url: string): Promise<void> => {
        return new Promise((resolve) => {
            if (this.loadedAssets.has(url)) {
                resolve();
            } else {
                const link = document.createElement('link');
                link.setAttribute('type', 'text/css');
                link.setAttribute('rel', 'stylesheet');
                link.setAttribute('media', 'all');
                link.setAttribute('href', url);
                link.onload = () => resolve();
                document.head.appendChild(link);
            }
        });
    };

    private checkForExistingScript = (url: string): boolean => {
        return !!document.querySelectorAll(`script[src="${url}"]`).length;
    };
}

interface Window {
    nbnAssetLoader: AssetLoader;
}
window.nbnAssetLoader = window.nbnAssetLoader || new AssetLoader();
